import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/OrderDetail/OrderDetail.js
const OrderDetail = () => (
  <NoSettings text="A single order for /customer-dashboard/my-order/:id. No settings." />
);

export default OrderDetail;
